import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { INTERVAL_NEW_MESSAGES } from 'constants/Environment';

import { getLiteral } from 'utils/getLiteral';
import { logEvent } from 'utils/tracking';
import { SidebarProvider, Sidebar } from '@Sage/ssm-web5';
import { getRoute, ensureRoute } from 'utils/routes';
import AnnounceKitComponent from 'containers/components/AnnounceKitComponent';
import MenuSampleData from 'containers/components/MenuSampleData';
import {
    getEnableTimeLine,
    getActivitiesNotificationsBadge,
} from 'containers/Activities/utils/timeline';

const PAGE_WIDGET_IMPLEMENTATIONS = [
    '34396', // FERROLI
    '58787', // AXA
    '66050', // AXA DUMMY
    '71124', // GES_SEGUROS
    '95083', // ECOCEMENTOS DUMMY
    '82658', // ECOCEMENTOS PRO
    '6001', // TOPCLIMA
    '6005', // TOPCLIMA_ONLINE
    '114835', // INDUSTRIASROYALTERMICSL
];

import {
    COMPANIES,
    CONTACTS,
    OPPORTUNITIES,
    ACTIVITIES,
    AGENDA,
    SALESORDERS,
    DOCUMENTS,
    PRODUCTS,
    KPIS,
    BILLBOARD,
    CAMPAIGNS,
    CONVERSATIONS,
    METRICS,
} from 'constants/Entities';

import { MessagesActions } from 'actions';

function mapStateToProps(state) {
    const idUser = state.config?.userData?.idUsuario;
    const messages = state.messages?.unread?.all?.entities;
    const activitiesNotificationsBadge = messages ? getActivitiesNotificationsBadge(messages) : 0;

    return {
        urlPath: window.location.href,
        literals: state.literal.literals,
        permission: state.config?.permission,
        idImplementation: state.config?.userData?.idImplementacion,
        idUser: idUser ? parseInt(idUser, 10) : 0,
        analyticsPro: state.config?.permission?.analyticsPro || false,
        lookerAnalyticsViewer: state.config?.userData?.lookerAnalyticsViewer || false,
        isImpersonated: state.config?.userData?.isImpersonated,
        forbiddenPage: state.entity.forbiddenPage || false,
        brandingWebColor: state.config?.permission?.brandingWebColor || null,
        customLogo: {
            square: state.config?.permission?.customerSidebarLogoSquareUrlWeb || null,
            rectangular: state.config?.permission?.customerSidebarLogoRectangularUrlWeb || null,
        },
        isDeletedWalkThroughData: state.config?.userData?.isDeletedWalkThroughData,
        subscriptionModeCode: state.config?.subscriptionModeCode,
        activitiesNotificationsBadge,
        showEntityPlaceholder: state.config?.showEntityPlaceholder,
        withDashboard: state.config.userData?.dashboardActive || false,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getUnreadMessages: bindActionCreators(MessagesActions, dispatch).getUnreadMessages,
    };
}

@connect(mapStateToProps, mapDispatchToProps)
class MainNavigationToolbar extends PureComponent {
    constructor(props) {
        super(props);

        this.sections = [];
        this.schema = {};
        this.navigateHandlers = {};
        this.onClickHandlers = {};
        this.initNavigationToolbar(props);
    }

    handleGetUnreadMessages() {
        // Getting user unread messages
        // TO-DO: Refactor whenever there's a websockets service available
        if (getEnableTimeLine() && !this.getUnreadMessagesInterval) {
            this.getUnreadMessagesInterval = setInterval(
                () => this.props.getUnreadMessages(),
                INTERVAL_NEW_MESSAGES,
            );
        }
    }

    componentDidMount() {
        this.handleGetUnreadMessages();
    }

    componentDidUpdate(prevProps) {
        const permissionsChanged = prevProps.permission !== this.props.permission;
        const activitiesBadgeChanged =
            prevProps.activitiesNotificationsBadge !== this.props.activitiesNotificationsBadge;

        if (permissionsChanged) {
            this.sections = [];
            this.schema = {};
            this.initNavigationToolbar(this.props);
            this.forceUpdate();
        } else if (activitiesBadgeChanged) {
            this.updateBadges(this.props);
        }

        if (prevProps.urlPath !== window.location.href) {
            this.updatePath();
        }

        this.handleGetUnreadMessages();
    }

    componentWillUnmount() {
        if (this.getUnreadMessagesInterval) clearInterval(this.getUnreadMessagesInterval);
    }

    onClick = (entityName, submodule) => {
        const key = `${entityName}-${submodule || ''}`;
        if (!this.onClickHandlers[key]) {
            this.onClickHandlers[key] = () => {
                let obj = {
                    event: entityName,
                    functionality: 'menuClick',
                };

                if (submodule) obj.submodule = submodule;

                logEvent(obj);
            };
        }
        return this.onClickHandlers[key];
    };

    navigate = (route) => {
        if (!this.navigateHandlers[route]) {
            this.navigateHandlers[route] = () => {
                ensureRoute(route);
            };
        }
        return this.navigateHandlers[route];
    };

    updateBadges = (props) => {
        const { activitiesNotificationsBadge } = props;

        const activitiesIndex = this.sections.findIndex((item) =>
            item.link?.includes(ACTIVITIES.route),
        );

        if (
            activitiesIndex !== -1 &&
            this.sections[activitiesIndex].badgeContent !== activitiesNotificationsBadge
        ) {
            this.sections = this.sections.map((item, index) =>
                index === activitiesIndex
                    ? { ...item, badgeContent: activitiesNotificationsBadge }
                    : item,
            );
            this.schema = { ...this.schema, menuItems: this.sections };
            this.forceUpdate();
        }
    };

    initNavigationToolbar = (props) => {
        const {
            permission,
            analyticsPro,
            lookerAnalyticsViewer,
            activitiesNotificationsBadge,
            showEntityPlaceholder,
            withDashboard,
        } = props;

        let accountsMenu = {
                type: 'link',
                icon: 'accounts',
                name: getLiteral('title_accounts'),
                link: getRoute(COMPANIES.route),
                navigate: this.navigate(COMPANIES.route),
                onClick: this.onClick(COMPANIES.trueName),
            },
            contactsMenu = {
                type: 'link',
                icon: 'contacts',
                name: getLiteral('title_contacts'),
                link: getRoute(CONTACTS.route),
                navigate: this.navigate(CONTACTS.route),
                onClick: this.onClick(CONTACTS.trueName),
            },
            activitiesMenu = {
                type: 'link',
                icon: 'activities',
                name: getLiteral('title_activities'),
                link: getRoute(ACTIVITIES.route),
                navigate: this.navigate(ACTIVITIES.route),
                entityConversationsLink: getRoute(`${CONVERSATIONS.route}${ACTIVITIES.route}`),
                hasBadge: true,
                badgeContent: activitiesNotificationsBadge,
            },
            agendaMenu = {
                type: 'link',
                icon: 'calendar',
                name: getLiteral('title_agenda'),
                link: getRoute(AGENDA.route),
                navigate: this.navigate(AGENDA.route),
                onClick: this.onClick(AGENDA.trueName),
            },
            documentsMenu = {
                type: 'link',
                icon: 'documents',
                name: getLiteral('title_documents'),
                link: getRoute(DOCUMENTS.route),
                navigate: this.navigate(DOCUMENTS.route),
                onClick: this.onClick(DOCUMENTS.trueName),
            },
            opportunitiesMenu = {
                type: 'link',
                icon: 'opportunities',
                name: getLiteral('title_opportunities'),
                link: getRoute(OPPORTUNITIES.route),
                navigate: this.navigate(OPPORTUNITIES.route),
                onClick: this.onClick(OPPORTUNITIES.trueName),
            },
            productsMenu = {
                type: 'link',
                icon: 'products',
                name: getLiteral('title_products'),
                link: getRoute(PRODUCTS.route),
                navigate: this.navigate(PRODUCTS.route),
                onClick: this.onClick(PRODUCTS.trueName),
            },
            salesordersMenu = {
                type: 'link',
                icon: 'salesOrders',
                name: getLiteral('title_salesorders'),
                link: getRoute(SALESORDERS.route),
                navigate: this.navigate(SALESORDERS.route),
                onClick: this.onClick(SALESORDERS.trueName),
            },
            kpisMenu = {
                type: 'link',
                icon: 'goals',
                name: getLiteral('title_admin_kpis'),
                link: getRoute(KPIS.route),
                navigate: this.navigate(KPIS.route),
                onClick: this.onClick(KPIS.trueName),
            },
            metricsMenu = {
                type: 'link',
                icon: 'analyticsPro',
                name: getLiteral('label_metrics_and_reports'),
                link: getRoute(METRICS.route),
                navigate: this.navigate(METRICS.route),
                onClick: this.onClick(METRICS.trueName),
            },
            billboardMenu = {
                type: 'link',
                icon: 'news',
                name: getLiteral('title_billboard_billboards'),
                link: getRoute(BILLBOARD.route),
                navigate: this.navigate(BILLBOARD.route),
                onClick: this.onClick(BILLBOARD.trueName),
            },
            campaignsMenu = {
                type: 'link',
                icon: 'campaigns',
                name: getLiteral('title_campaigns'),
                link: getRoute(CAMPAIGNS.route),
                navigate: this.navigate(CAMPAIGNS.route),
                onClick: this.onClick(CAMPAIGNS.trueName),
            },
            customPageMenu = {
                type: 'link',
                icon: 'widgets',
                name: getLiteral('title_custom_page'),
                link: getRoute('/custom-page'),
                navigate: this.navigate('/custom-page'),
            },
            dashboardMenu = {
                type: 'link',
                icon: 'dashboardWeb',
                name: getLiteral('title_dashboard'),
                link: getRoute('/dashboard'),
                navigate: this.navigate('/dashboard'),
            };

        if (withDashboard) {
            this.sections.push(dashboardMenu);
        }

        // Accounts
        if (permission['empresas']) {
            this.sections.push(accountsMenu);
        }

        // Contacts
        if (permission['contactos']) {
            this.sections.push(contactsMenu);
        }

        // Activities
        if (permission['gestiones']) {
            this.sections.push(activitiesMenu);
        }

        // Agenda
        if (permission['calendar']) {
            this.sections.push(agendaMenu);
        }

        // Opportunities
        if (permission['expedientes']) {
            this.sections.push(opportunitiesMenu);
        }

        // products
        if (permission['tarifa']) {
            this.sections.push(productsMenu);
        }

        // salesorders
        if (permission['salesOrders']) {
            this.sections.push(salesordersMenu);
        }

        // documents
        if (permission['documentManagement'] && permission['documentos_general']) {
            this.sections.push(documentsMenu);
        }

        if (
            (permission['informes'] && permission['reports_general']) ||
            permission['sfm'] ||
            analyticsPro
        ) {
            this.sections.push(metricsMenu);
        }

        // kpis
        if (permission['kpisPremium']) {
            this.sections.push(kpisMenu);
        }

        // billboard
        if (permission['billboard']) {
            this.sections.push(billboardMenu);
        }

        // campaigns
        if (permission['verCampaignsAdmin']) {
            this.sections.push(campaignsMenu);
        }

        // custom page
        let customPageActive =
            props.idImplementation &&
            PAGE_WIDGET_IMPLEMENTATIONS.indexOf(props.idImplementation) !== -1;
        if (permission['custom_page'] && customPageActive) {
            this.sections.push(customPageMenu);
        }

        // AddOns Placeholders
        if (
            (!permission['kpisPremium'] ||
                !permission['salesOrders'] ||
                !permission['tarifa'] ||
                !permission['billboard'] ||
                !permission['verCampaignsAdmin']) &&
            permission['viewAddonsConfiguration']
        ) {
            if (!permission['kpisPremium'] && showEntityPlaceholder?.[KPIS.entity])
                this.sections.push({
                    type: 'link',
                    icon: 'goals',
                    link: getRoute('/try-kpis'),
                    name: getLiteral('title_admin_kpis'),
                    hasTrial: true,
                    onClick: this.onClick(KPIS.trueName, 'addons'),
                });
            if (!permission['salesOrders'] && showEntityPlaceholder?.[SALESORDERS.entity])
                this.sections.push({
                    type: 'link',
                    icon: 'salesOrders',
                    link: getRoute('/try-sales-orders'),
                    name: getLiteral('title_salesorders'),
                    hasTrial: true,
                    onClick: this.onClick(SALESORDERS.trueName, 'addons'),
                });
            if (!permission['tarifa'] && showEntityPlaceholder?.[PRODUCTS.entity])
                this.sections.push({
                    type: 'link',
                    icon: 'products',
                    link: getRoute('/try-products'),
                    name: getLiteral('title_products'),
                    hasTrial: true,
                    onClick: this.onClick(PRODUCTS.trueName, 'addons'),
                });
            if (!permission['billboard'] && showEntityPlaceholder?.[BILLBOARD.entity])
                this.sections.push({
                    type: 'link',
                    icon: 'news',
                    link: getRoute('/try-newsmanager'),
                    name: getLiteral('title_billboard_billboards'),
                    hasTrial: true,
                    onClick: this.onClick(BILLBOARD.trueName, 'addons'),
                });
            if (!permission['verCampaignsAdmin'] && showEntityPlaceholder?.[CAMPAIGNS.entity])
                this.sections.push({
                    type: 'link',
                    icon: 'campaigns',
                    link: getRoute('/try-salescampaigns'),
                    name: getLiteral('title_campaigns'),
                    hasTrial: true,
                    onClick: this.onClick(CAMPAIGNS.trueName, 'addons'),
                });
        }

        this.schema = { appName: 'web', homeLink: '/', menuItems: [...this.sections] };
    };

    updatePath = () => {
        const path = window.location.href;
        return path;
    };

    onMatchActive = (item) => {
        if (!item.link) return;
        const cleanLink = item.link;

        // Avoiding double selection
        if (cleanLink?.includes('web3/index') && window.location.pathname.includes('web3/index')) {
            return true;
        } else if (window.location.pathname.includes('web3/index')) {
            return false;
        }

        let selected =
            window.location.href.includes(cleanLink) ||
            cleanLink === window.location.pathname ||
            window.location.href.includes(item.entityConversationsLink) ||
            item.entityConversationsLink === window.location.pathname ||
            (window.location.hash &&
                window.location.hash !== '#/' &&
                cleanLink?.includes(window.location.hash));

        return selected;
    };

    getPostComponent = (props) => {
        const { isDeletedWalkThroughData, subscriptionModeCode, isImpersonated, permission } =
            this.props;

        if (!isDeletedWalkThroughData && subscriptionModeCode === 'free_trial')
            return <MenuSampleData {...props} />;

        if (!isImpersonated && permission.enableAnnounceKitOption)
            return <AnnounceKitComponent {...props} />;

        return null;
    };

    render() {
        if (this.props.forbiddenPage) return null;

        return (
            <SidebarProvider>
                <Sidebar
                    schema={this.schema}
                    currentHref={this.updatePath()}
                    onMatchActive={this.onMatchActive}
                    onExpand={this.props.onExpand}
                    getPostComponent={this.getPostComponent}
                    customColor={this.props.brandingWebColor}
                    customLogo={this.props.customLogo}
                />
            </SidebarProvider>
        );
    }
}

export default MainNavigationToolbar;
